import { useDispatch, useSelector } from 'react-redux'
import { NotificationState, Notification_Actions } from 'shared/stores'
import { NotificationTypeEnum } from 'shared/types'

export interface HTML_Notification_Props {
  text: string
  title: string
  timeout: number
  type: NotificationTypeEnum
}

export default function useNotification() {
  const dispatch = useDispatch()
  const notifications = useSelector(
    (state: NotificationState) => state.notifications.NOTIFICATIONS,
  )

  function html_notification({ title, text, timeout, type }: HTML_Notification_Props) {
    dispatch({
      type: Notification_Actions.ADD_NOTIFICATION,
      payload: { title, text, id: notifications.length, type },
    })

    setTimeout(() => {
      dispatch({
        type: Notification_Actions.DELETE_NOTIFICATION,
        payload: { title, text, id: notifications.length },
      })
    }, timeout * 1000)

    return
  }

  return {
    html_notification,
  }
}
